import GoogleIcon from '@mui/icons-material/Google';
import { LoadingButton } from '@mui/lab';
import { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import useAsyncDisconnectGoogleAuth from '../../../../hooks/useAsyncDisconnectGoogleAuth';
import useLoadGsiScript from '../../../../hooks/useLoadGsiScript';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { createToast } from '../../../../store/notify';
import { requestConfig } from '../../../../store/users';
import { createErrorToast } from '../../../../utils/notifyHelpers';

export default function DisconnectGoogleAccount() {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();

    const userState = useAppSelector(state => {
        return {
            userGoogleAccountId: state.user.googleAccountId || null,
            clientId: state.user.clientId,
            userName: state.user.userName,
        };
    });

    const loaded = useLoadGsiScript();
    const googleClientRef = React.useRef<any>();
    const [loginHash, setLoginHash] = React.useState<string>('');
    const { asyncDisconnectGoogleAuth, requestStatus } = useAsyncDisconnectGoogleAuth();

    //trigger the signin consent flow (popup)
    const handleSignIn = () => {
        console.log('handleSignIn');
        if (googleClientRef.current) {
            googleClientRef.current.requestCode();
        } else {
            const toastData = createErrorToast(
                'Could not attempt Sign In. Please try again later.',
            );
            dispatch(createToast({ toastData }));
        }
    };

    const handleDisconnect = async () => {
        await asyncDisconnectGoogleAuth();

        dispatch(requestConfig());
    };

    return (
        <>
            <Typography component="p" variant="body2">
                Connected to: <strong>{userState.userGoogleAccountId}</strong>
            </Typography>
            <LoadingButton onClick={handleDisconnect} variant="outlined" startIcon={<GoogleIcon />}>
                Disconnect Google Account
            </LoadingButton>
        </>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({}));
